import { createAsyncThunk } from "@reduxjs/toolkit";

import {
  addTagsData,
  deleteTagssData,
  fetchTags,
  updateTagsList,
} from "../../apis/tags";

export const fetchTagsList = createAsyncThunk(
  "gates/fetchTags",
  async (_, { rejectWithValue }) => {
    try {
      const gates = await fetchTags();
      return gates;
    } catch (error: any) {
      console.log(error);
      return rejectWithValue(error.message);
    }
  }
);

export const updateGates = createAsyncThunk(
  "gates/updateGates",
  async (
    {
      tag_id,
      data,
    }: {
      tag_id: string;
      data: {
        [key: string]: any;
        tag_id: string;
      };
    },
    { rejectWithValue }
  ) => {
    try {
      await updateTagsList(tag_id, data);
      return { success: true, data };
    } catch (error: any) {
      console.log(error);
      return rejectWithValue(error.message);
    }
  }
);

export const deleteTags = createAsyncThunk(
  "gates/deleteTags",
  async (
    {
      id,
    }: {
      id: string;
    },
    { rejectWithValue }
  ) => {
    try {
      const response = await deleteTagssData(id);
      return response;
    } catch (error: any) {
      console.log(error);
      return rejectWithValue(error.message);
    }
  }
);

export const addNewTagsData = createAsyncThunk(
  "gates/addGates",
  async (
    {
      data,
    }: {
      data: {
        [key: string]: any;
      };
    },
    { rejectWithValue }
  ) => {
    try {
      const response = await addTagsData(data);
      return response;
    } catch (error: any) {
      console.log(error);
      return rejectWithValue(error.message);
    }
  }
);
